import { useTracking } from '@repo/tracking/use-tracking';
import useSWRImmutable from 'swr/immutable';

import type { FeatureFlagKey, FeatureFlag } from '@repo/types/feature-flag';

export const useFeatureFlag = (featureKey: FeatureFlagKey) => {
  const { trackExperiment } = useTracking();

  return useSWRImmutable(
    `/protected/api/loyalty-management/feature/${featureKey}`,
    async (url: string): Promise<FeatureFlag> => {
      const response = await fetch(url, { signal: AbortSignal.timeout(1000) });
      if (response.status >= 400) {
        throw new Error(`Error fetching feature flag: ${response.statusText}`);
      }
      return await response.json();
    },
    {
      shouldRetryOnError: false,
      onSuccess: (data) => {
        if (data.enabled && data.variationKey !== 'on') {
          trackExperiment({ featureKey, variationKey: data.variationKey });
        }
      },
    },
  );
};
